import { render, staticRenderFns } from "./AddFeedbackInTemplate.vue?vue&type=template&id=21e91308&scoped=true&"
import script from "./AddFeedbackInTemplate.vue?vue&type=script&lang=js&"
export * from "./AddFeedbackInTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AddFeedbackInTemplate.vue?vue&type=style&index=0&id=21e91308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e91308",
  null
  
)

export default component.exports